import { createFileRoute, Outlet, useMatchRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/notices")({
  component: NoticesLayout,
});

function NoticesLayout() {
  const matchRoute = useMatchRoute();
  // Both editors — the template family's and one letter's — are full-height
  // surfaces; render them full-bleed so they own the whole viewport (the
  // h-full contract they size against).
  const onEditor =
    Boolean(matchRoute({ to: "/notices/templates/$id", fuzzy: false })) ||
    Boolean(matchRoute({ to: "/notices/$id/edit", fuzzy: false }));
  if (onEditor) {
    // The shell's `main` reserves `pb-24` under every page so the fixed
    // quick-actions launcher never lands on a page's trailing control. A
    // full-height editor has no trailing control and sizes itself against that
    // padded content box, so the reserve reads as a dead band under the sheet.
    // Growing by exactly the reserve and pulling it back with the negative
    // margin hands the editor the whole viewport without making the shell
    // scroll — 6rem is `pb-24`; the two move together.
    return (
      <div className="-mb-24 h-[calc(100%+6rem)] print:mb-0 print:h-full">
        <Outlet />
      </div>
    );
  }
  // Every other notices page owns its own `p-8` wrapper, so the layout adds
  // no width or padding of its own.
  return <Outlet />;
}
